/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

export function extractNumFromString(input: string): number {
  const match = input.match(/\d/g) ?? [""];
  return parseInt(match.join(""), 10);
}

export function extractId<T extends { id?: string; nid?: string }>(item: T) {
  return item?.id ?? item?.nid ?? "";
}
